export default __webpack_public_path__ + "static/media/Navidad(360x600).39df70cf.webp";